// New case and the bulk import warn in the same words.
export const RESTRICTED_NAME_WARNING = 'A restricted client with this name already exists — ask an admin before creating a new one'
